module.exports = __webpack_public_path__ + "img/blood_fiend_small.70a89f1c.png";